<form [formGroup]="warrantyActivationFormGroup"  id="step-serial-number-search" class="h-full">
  <div class="flex flex-1 flex-col rounded-card h-full overflow-visible pb-6">
    <section class="row">
      <div class="flex flex-col col-12">
        <h2 data-testid="activation-title"  class="pb-2">{{ 'WARRANTY_ACTIVATION.WARRANTY_ACTIVATION_DETAILS' | translate }}</h2>
      </div>
      <div class="field-wr flex flex-col col-12 col-sm-12 col-md-4 col-lg-3 col-xl-3">
        <span class="label mb-3" for="manualActivationDate">{{ 'WARRANTY_ACTIVATION.LABEL_SET_MANUAL_ACTIVATION_DATE' | translate }}:</span>
        <div class="row mb-3">
          <div class="col-12">
            <span class="inline-flex mr-6">
              <p-radioButton name="manualActivationDate" value="true" formControlName="manualActivationDate" inputId="yes" />
              <label for="yes" class="ml-2">{{ 'BOOLEANS.YES' | translate }}</label>
            </span>
            <span class="inline-flex mr-2">
              <p-radioButton name="manualActivationDate" value="false" formControlName="manualActivationDate" inputId="no" />
              <label for="no" class="ml-2">{{ 'BOOLEANS.NO' | translate }}</label>
            </span>
          </div>
        </div>
      </div>
      <div class="field-wr flex flex-col col-12 col-sm-12 col-md-4 col-lg-3 col-xl-3" [ngClass]="{'disabled': warrantyActivationFormGroup.get('manualActivationDate')?.value == 'false'}">
        <label data-testid="activation-date-label" class="block text-sm" for="activationDate">{{ 'WARRANTY_ACTIVATION.ACTIVATION_DATE' | translate }}:<i class="pi pi-question-circle" role="tooltip" pTooltip="{{ 'TOOLTIP.DATE_FORMAT' | translate }}" tooltipPosition="top"
          id="dateTooltip"></i></label>
        <p-datepicker data-testid="activation-date"  formControlName="activationDate" dateFormat="dd-mm-yy" [maxDate]="currentDate" placeholder="{{ 'MODALBOXES.RETURN_DATE_PLACEHOLDER' | translate }}" showIcon="true" [showTime]="true" appendTo="body" inputId="activationDate" />
      </div>
      <!-- /form fields -->
    </section>
    <section class="row">
      <div class="flex flex-col col-12">
        <h2 data-testid="activation-warranty-summary-title" class="pb-2">{{ 'WARRANTY_ACTIVATION.WARRANTY_ACTIVATION_SUMMARY' | translate }}</h2>
      </div>
      <hr role="presentation" class="w-full mt-1 mb-2 border-t">
      <div class="row mt-3 mb-3">
        <div class="col-12 col-sm-12 col-md-4 col-lg-3">
          <img [src]="previewImageUrl" [alt]="productMetadata?.name || ''" class="w-100 mt-2 featured-image summary-thumbnail">
        </div>
        <div class="col-12 col-sm-12 col-md-8 col-lg-9">
          <dl class="details-grid mt-3">
            <dt data-testid="product-name-label" class="label grid-cols-1 pt-3">{{ 'WARRANTY_ACTIVATION.PRODUCT_NAME' | translate }}</dt>
            <dd data-testid="product-name" class="value pt-3 pb-3">{{ productMetadata?.name | defaultValue }}</dd>

            <dt data-testid="sku-label" class="label grid-cols-1 pt-3">{{ 'WARRANTY_ACTIVATION.SKU' | translate }}</dt>
            <dd data-testid="sku" class="value pt-3 pb-3">{{ sku | defaultValue }}</dd>

            <dt data-testid="serialnumber-label" class="label grid-cols-1 pt-3">{{ 'WARRANTY_ACTIVATION.SERIAL_NUMBER' | translate }}</dt>
            <dd data-testid="serialnumber-label" class="value pt-3 pb-3">{{ serialNumber | defaultValue }}</dd>

            <dt data-testid="warrantycode-label" class="label grid-cols-1 pt-3">{{ 'WARRANTY_ACTIVATION.WARRANTY_CODE' | translate }}</dt>
            <dd data-testid="warrantycode" class="value pt-3 pb-3">{{ warrantyCode | defaultValue }}</dd>
          </dl>
          <div class="row mt-3">
            <div class="col-4">
              <button data-testid="activate-warranty-btn" class="btn primary-btn w-full" (click)="onSaveStepData()">{{ 'WARRANTY_ACTIVATION.BTN_ACTIVATE_WARRANTY' | translate }}</button>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</form>
